export class CostCenter {
    constructor(json) {
        this.id = json.id;
        this.label = json.label;
        this.description = json.description;
        this.ownerId = json.owner_id;
        this.divisionIds = new Set(json.divisions);
        this.locationIds = new Set(json.locations);
    }
    get name() {
        return this.label;
    }
}
//# sourceMappingURL=CostCenter.js.map